<script lang="ts" setup>
import type { IHomeHenceLifestyle } from '@/utils/types'
const props = defineProps({
  items: {
    type: Array as PropType<IHomeHenceLifestyle[]>,
    default: () => ({})
  }
})

const item = computed(() => props.items.length > 0 ? props.items[0] : null)
</script>

<template>
  <section class="experience" v-if="item !== null">
    <div class="experience__inner">
      <Intro subtitle="new experience" :data="{
        title: '種種生活'
      }" class="align-left display80 brand3 article__intro" />
      <div class="experience__bottom">
        <figure class="experience__pic">
          <Nimg :src="item?.lg_image?.link" :alt="item?.lg_image?.alt || '種種生活圖1'" :title="item?.lg_image?.title" />
        </figure>
        <div class="experience__lists">
          <div class="experience__lists__item" v-for="x in item.content">
            <div class="experience__lists__title">{{ x.title }}</div>
            <div class="experience__lists__text">{{ x.text }}</div>
          </div>
        </div>
        <div class="experience__view">
          <figure class="experience__view__pic">
            <Nimg :src="item?.sm_image?.link" :alt="item?.sm_image?.alt || '種種生活圖2'" :title="item?.sm_image?.title" />
          </figure>
          <nuxt-link :to="`/hence/article/${item.id}`" class="experience__view__link">
            立即探索
            <IconArrow />
          </nuxt-link>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.experience {
  position: relative;
  z-index: 1;
  background-color: $color-white-2;
  padding: toRem(110) toRem(105) toRem(80);
  margin-bottom: toRem(83);

  @include max-media(990) {
    padding: toRem(80) toRem(24) toRem(50);
  }

  &::before {
    content: '';
    position: absolute;
    right: 0;
    top: toRem(80);
    width: toRem(88);
    height: 50%;
    background-color: $color-white-1;
    z-index: -1;

    @include min-media(768) {
      display: none;
    }
  }

  &::after {
    content: '';
    position: absolute;
    left: toRem(24);
    bottom: 0;
    z-index: -1;
    width: 80%;
    height: 50%;
    background-color: $color-white-1;

    @include max-media(767) {
      left: 0;
      width: toRem(88);
    }
  }

  &__inner {
    padding: toRem(40) toRem(60) toRem(70);
    background-color: $color-white-1;

    @include max-media(767) {
      padding: toRem(17) toRem(32) toRem(17);
    }
  }

  &__intro {
    margin-bottom: toRem(32);
  }

  &__bottom {
    display: flex;

    @include max-media(767) {
      flex-direction: column;
    }
  }

  &__pic {
    width: 55%;
    margin-right: toRem(32);

    @include max-media(767) {
      width: calc(100% + toRem(64));
      margin-right: toRem(0);
      margin-left: toRem(-32);
      margin-bottom: toRem(44);
    }

    img {
      display: block;
      width: 100%;
    }
  }

  &__lists {
    width: 22%;
    margin-top: auto;
    margin-right: toRem(32);

    @include max-media(767) {
      width: 100%;
      margin-right: 0;
    }

    &__item {
      &:not(:last-child) {
        margin-bottom: toRem(24);
      }
    }

    &__title {
      font-size: toRem(16);
      font-weight: 700;
      line-height: 1.6;
      color: $color-brand-3;
    }

    &__text {
      color: $color-black-1;
      font-size: toRem(14);
      line-height: 1.3;
    }
  }

  &__view {
    width: 16%;

    @include max-media(767) {
      width: 100%;
      max-width: toRem(147);
      margin-left: auto;
      margin-right: auto;
    }

    &__pic {
      width: 100%;

      img {
        display: block;
        width: 100%;
      }
    }

    &__link {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: toRem(16);
      font-weight: 700;
      line-height: 1.6;
    }
  }
}
</style>
